var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
import { GenericError as GenericError2 } from "@auth0/auth0-spa-js";

// src/standalone-auth.ts
import { GenericError } from "@auth0/auth0-spa-js";

// src/auth-client.ts
import createAuth0Client from "@auth0/auth0-spa-js";
var _auth0ClientPromise, _redirectLoginOptions, _onAuthListeners;
var AuthClient = class {
  constructor(params) {
    __privateAdd(this, _auth0ClientPromise, void 0);
    __privateAdd(this, _redirectLoginOptions, void 0);
    __privateAdd(this, _onAuthListeners, /* @__PURE__ */ new Set());
    if (!(params == null ? void 0 : params.clientOptions)) {
      throw new Error("clientOptions cannot be null");
    }
    __privateSet(this, _auth0ClientPromise, createAuth0Client(params.clientOptions));
    __privateSet(this, _redirectLoginOptions, params.redirectLoginOptions || {});
  }
  addOnAuthListener(listener) {
    __privateGet(this, _onAuthListeners).add(listener);
    return () => {
      __privateGet(this, _onAuthListeners).delete(listener);
    };
  }
  getAuth0Client() {
    return __async(this, null, function* () {
      return __privateGet(this, _auth0ClientPromise);
    });
  }
  isAuthenticated() {
    return __async(this, null, function* () {
      const client = yield this.getAuth0Client();
      return client.isAuthenticated();
    });
  }
  getTokenSilently(options) {
    return __async(this, null, function* () {
      const client = yield this.getAuth0Client();
      return client.getTokenSilently(options);
    });
  }
  getUser(options) {
    return __async(this, null, function* () {
      const client = yield this.getAuth0Client();
      return client.getUser(options);
    });
  }
  loginWithRedirect() {
    return __async(this, arguments, function* (options = {}) {
      const client = yield this.getAuth0Client();
      return client.loginWithRedirect(__spreadValues(__spreadValues({}, __privateGet(this, _redirectLoginOptions)), options));
    });
  }
  logout(logoutOptions) {
    return __async(this, null, function* () {
      const client = yield this.getAuth0Client();
      return client.logout(logoutOptions);
    });
  }
  handleRedirectCallback() {
    return __async(this, null, function* () {
      const client = yield this.getAuth0Client();
      const result = yield client.handleRedirectCallback();
      __privateGet(this, _onAuthListeners).forEach((listener) => listener());
      return result;
    });
  }
  getIdTokenClaims() {
    return __async(this, null, function* () {
      const client = yield this.getAuth0Client();
      return client.getIdTokenClaims();
    });
  }
};
_auth0ClientPromise = new WeakMap();
_redirectLoginOptions = new WeakMap();
_onAuthListeners = new WeakMap();

// src/standalone-auth.ts
var _authClient;
var StandaloneAuthWrapper = class {
  constructor() {
    __privateAdd(this, _authClient, null);
  }
  initialize(config) {
    __privateSet(this, _authClient, new AuthClient(config));
  }
  get initialized() {
    return !!__privateGet(this, _authClient);
  }
  get client() {
    if (!__privateGet(this, _authClient)) {
      throw new Error("StandaloneAuth was not initialized");
    }
    return __privateGet(this, _authClient);
  }
};
_authClient = new WeakMap();
var StandaloneAuth = new StandaloneAuthWrapper();
var isLoginRequiredError = (e) => e instanceof GenericError && e.error === "login_required";
export {
  GenericError2 as GenericError,
  StandaloneAuth,
  isLoginRequiredError
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/auth-standalone'] = window.leagueSDKsPresent['@leagueplatform/auth-standalone'] || [];
    window.leagueSDKsPresent['@leagueplatform/auth-standalone'].push('2.23.5');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/auth-standalone'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/auth-standalone module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map